import { Typography } from 'lighthouse';

import { ShelfFooterProps } from './models';

import { TickCircle } from 'iconsax-react';

export const ShelfFooter = ({ trustPoints, dark = false }: ShelfFooterProps) => (
    <div className='mt-4 flex items-center justify-center md:mt-5 md:justify-start'>
        <ul className='m-0 flex list-none flex-wrap items-center justify-center gap-x-5 gap-y-2 p-0 md:justify-start'>
            {trustPoints.map((point) => (
                <li key={point} className={`flex items-center gap-1.5 ${dark ? 'text-emerald-300' : 'text-success'}`}>
                    <TickCircle size={16} color='currentColor' variant='Bold' className='shrink-0' aria-hidden />
                    <Typography
                        variant='caption'
                        component='span'
                        color={dark ? 'whiteMediumEmphasis' : 'blackMediumEmphasis'}
                        className={`leading-6 ${dark ? 'text-white/70' : ''}`}>
                        {point}
                    </Typography>
                </li>
            ))}
        </ul>
    </div>
);
